/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_activate_card_benefit_4 = /** @type {(inputs: {}) => string} */ () => {
	return `Seguridad avanzada: tokenización, CVV y bloqueo instantáneo`
};

const en_organization_activate_card_benefit_4 = /** @type {(inputs: {}) => string} */ () => {
	return `Advanced security: tokenization, CVV and instant lock`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_activate_card_benefit_4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_activate_card_benefit_4(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_activate_card_benefit_4", locale)
	if (locale === "es") return es_organization_activate_card_benefit_4(inputs)
	return en_organization_activate_card_benefit_4(inputs)
};
export { organization_activate_card_benefit_4 as "organization.activate_card.benefit_4" }